import React, { useState, useEffect } from "react";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
//import { default as Form, default as SettingsForm } from "./scenes/form";

import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

//import React, { useEffect, useState } from "react";
import Sets from "./scenes/sets";
import Cards from "./scenes/cards";
import Users from "./scenes/users";
import Dashboard from "./scenes/dashboard";



export const learncardsContext = React.createContext();

function App({ gitRevision, stage }) {
  const [theme, colorMode] = useMode();

  const [loading, setLoading] = useState(false);

  const [alertMessage, setAlertMessage] = useState("");

  const [cardData, setCardData] = useState("");

  const [selectedOption, setSelectedOption] = useState("");

  const [selected, setSelected] = useState("Dashboard");

  const [options, setOptions] = useState([]);

  const [userInfo, setUserInfo] = useState("");

  const [exerciseChecked, setExerciseChecked] = useState(false); // State for "Exercise" checkbox

  // New effect to handle exerciseChecked based on user role
  useEffect(() => {
    if (userInfo && userInfo.role !== 'L2') {
      setExerciseChecked(true);
    }
  }, [userInfo]);

  // Modified setExerciseChecked function
  const handleExerciseChecked = (value) => {
    if (userInfo && userInfo.role === 'L2') {
      setExerciseChecked(value);
    } else {
      setExerciseChecked(true);
    }
  };

  console.log("Options:", options); // Log the value of options


  return (
    <learncardsContext.Provider
      value={{
        loading,
        setLoading,
        alertMessage,
        setAlertMessage,
        cardData,
        setCardData,
        selectedOption,
        setSelectedOption,
        setOptions,
        options,
        exerciseChecked,
        setExerciseChecked: handleExerciseChecked,
        userInfo,
        setUserInfo,
        selected,
        setSelected
      }}
    >
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className={`app ${stage} `}>
            <Sidebar />
            <main className="content">
              <Topbar />
              <Routes>
                {<Route path="/" element={<Dashboard />} />}
                {<Route path="/sets" element={<Sets />} />}
                {<Route path="/cards" element={<Cards />} />}
                {<Route path="/users" element={<Users />} />}
              </Routes>
            </main>
          </div>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </learncardsContext.Provider>
  );
}

export default App;
//export default withAuthenticator(App);
